/* Bushbalm Quiz v19: reads the live Quiz Kit screen and adds data-bb-* hooks for the stylesheet.
   Never replaces images, answers or selection. Edit INTRO / QUESTIONS to change copy, step or layout. */
(function () {
  if (window.__bbQuizV19) return;
  window.__bbQuizV19 = true;

  var ROOT = '[data-quiz-kit-key="vZlZv8G6M"]';
  // Every branch is 5 questions long: Q1 → one of four 3-question branches → "How would you like to get started?"
  var TOTAL_STEPS = 5;
  var MEDIA_WAIT_MS = 4000;
  var INTRO = { eyebrow: 'The Bushbalm quiz', note: 'Takes 2 minutes' };
  // Keyed by Quiz Kit question id (the number at the end of quiz-kit-question-title-…), so title edits don't break styling.
  // style: 'cards' (image tiles) or 'rows' (thumbnail + label). All questions are single-select.
  // Questions not listed still get card styling and history-based progress, just no eyebrow or subtitle.
  var QUESTIONS = {
    // Shared opener
    222797: { step: 1, style: 'cards', eyebrow: 'Your goals',    sub: 'Choose the one that feels most important right now.' }, // What brings you here today?
    // Branch: Ingrown hairs & razor bumps
    222798: { step: 2, style: 'rows',  eyebrow: 'Your routine',  sub: 'Choose the method you use most often.' },               // How do you usually remove hair?
    222799: { step: 3, style: 'rows',  eyebrow: 'Your skin',     sub: 'Choose the one that matters most to you.' },            // What does your skin need most?
    222800: { step: 4, style: 'cards', eyebrow: 'Your scent',    sub: 'We’ll use this to pick the scent of your products.' },  // Which scent feels most like you?
    // Branch: Dark spots & uneven tone
    222801: { step: 2, style: 'cards', eyebrow: 'Your focus',    sub: 'Choose the area you care about most.' },                // Where are you focusing your skincare?
    222802: { step: 3, style: 'rows',  eyebrow: 'Your concerns', sub: 'Choose the result you’re hoping to see.' },              // What would you most like to improve?
    222803: { step: 4, style: 'rows',  eyebrow: 'Your routine',  sub: 'Choose the kind of care that fits your day.' },         // What kind of brightening care sounds best?
    // Branch: A smoother, more comfortable shave
    222804: { step: 2, style: 'cards', eyebrow: 'Your focus',    sub: 'Choose where you shave most often.' },                  // Where do you usually shave?
    222805: { step: 3, style: 'rows',  eyebrow: 'Your concerns', sub: 'Choose the one that bothers you most.' },               // What's your biggest shaving frustration?
    222806: { step: 4, style: 'cards', eyebrow: 'Your scent',    sub: 'We’ll use this to pick the scent of your products.' },  // Which scent would you reach for?
    // Branch: Trimming & grooming
    222807: { step: 2, style: 'cards', eyebrow: 'Your focus',    sub: 'Choose where you’d like to use your tools.' },          // Where do you want to groom?
    222808: { step: 3, style: 'rows',  eyebrow: 'Your routine',  sub: 'Choose the style that sounds most like you.' },         // What kind of grooming do you prefer?
    222809: { step: 4, style: 'rows',  eyebrow: 'Your tools',    sub: 'Choose what would help you most.' },                    // What would make grooming easier?
    // Shared closer
    222810: { step: 5, style: 'rows',  eyebrow: 'Last step',     sub: 'Choose how much you’d like to start with.' }            // How would you like to get started?
  };
  // A duplicated Quiz Kit quiz receives new question IDs. Use its visible question titles
  // to preserve the exact layout, eyebrow, subtitle and progress step.
  // IDs in QUESTIONS still work for the original quiz, but titles work for a duplicate.
  var QUESTION_BY_TITLE = {
    'what brings you here today?': 222797,
    'how do you usually remove hair?': 222798,
    'what does your skin need most?': 222799,
    'which scent feels most like you?': 222800,
    'where are you focusing your skincare?': 222801,
    'what would you most like to improve?': 222802,
    'what kind of brightening care sounds best?': 222803,
    'where do you usually shave?': 222804,
    "what’s your biggest shaving frustration?": 222805,
    "what's your biggest shaving frustration?": 222805,
    'which scent would you reach for?': 222806,
    'where do you want to groom?': 222807,
    'what kind of grooming do you prefer?': 222808,
    'what would make grooming easier?': 222809,
    'how would you like to get started?': 222810
  };
  function normalizeTitle(text) {
    return String(text || '').toLowerCase().replace(/\s+/g,' ').replace(/[’]/g,"'").trim();
  }
  var history = [];
  var lastQuestionId = null;
  var lastMediaSrc = null;
  function replay(el, attr) {
    if (!el) return;
    el.removeAttribute(attr);
    void el.offsetWidth; // restart the CSS animation
    el.setAttribute(attr, '');
  }
  var panelSeen = new WeakMap();
  function stepFor(key) {
    var at = history.indexOf(key);
    if (at === -1) history.push(key); else history.length = at + 1; // going Back trims the path
    return history.length;
  }
  function clearBackgrounds(root, inner) {
    for (var n = inner && inner.parentElement; n && n !== root.parentElement; n = n.parentElement) {
      setAttr(n, 'data-bb-chain', '');
    }
  }
  function findBack(scope, next) {
    // Visible text only: ignore text inside icons (an SVG's hidden <title>Back</title> was being matched).
    var ICON = 'svg, img, picture, i, title, desc';
    var textOf = function (el) {
      var out = '';
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      for (var n = walker.nextNode(); n; n = walker.nextNode()) {
        var p = n.parentElement;
        if (p && p.closest(ICON) && el.contains(p.closest(ICON))) continue;
        out += n.nodeValue;
      }
      return norm(out);
    };
    var isBack = function (el) { return !!el && !el.matches(ICON) && /^\W*back\W*$/i.test(textOf(el)); };
    var clashes = function (el) { return el === scope || el.id === 'quiz-kit-question-navigation' || (next && (el === next || el.contains(next))); };
    var all = scope.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (clashes(el) || (next && next.contains(el)) || el.closest(ICON) || !isBack(el)) continue;
      // Climb to the outermost element whose visible text is still just "Back" (label + its icon).
      while (el.parentElement && !clashes(el.parentElement) && isBack(el.parentElement)) el = el.parentElement;
      return el;
    }
    return null;
  }




  var norm = function (s) { return String(s || '').replace(/\s+/g, ' ').trim(); };
  var shown = function (el) { return !!(el && el.getClientRects().length); };
  function setAttr(el, name, value) {
    if (!el) return;
    if (value === null) { if (el.hasAttribute(name)) el.removeAttribute(name); return; }
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function common(a, b) {
    for (var n = a; n; n = n.parentElement) if (n.contains(b)) return n;
    return null;
  }
  function childOf(ancestor, node) {
    while (node && node.parentElement !== ancestor) node = node.parentElement;
    return node;
  }

  function syncIntro(root, intro) {
    setAttr(root, 'data-bb-layout', 'intro');
    history.length = 0;
    setAttr(intro, 'data-bb-eyebrow', INTRO.eyebrow);
    var button = root.querySelector('#quiz-kit-intro-button');
    if (button) setAttr(button.parentElement, 'data-bb-note', INTRO.note);
    var media = root.querySelector('[id^="quiz-kit-intro-content-image"]');
    if (media && !intro.contains(media) && !media.contains(intro)) {
      var shell = common(intro, media);
      setAttr(shell, 'data-bb-intro-shell', '');
      setAttr(childOf(shell, media), 'data-bb-intro-media', '');
      setAttr(childOf(shell, intro), 'data-bb-intro-copy', '');
      clearBackgrounds(root, shell);
    }
  }

  function syncQuestion(root, title) {
    var id = (title.id.match(/(\d+)$/) || [])[1];
    var sourceId = QUESTION_BY_TITLE[normalizeTitle(title.textContent)];
    var q = QUESTIONS[id] || QUESTIONS[sourceId] || { style: 'cards' };
    var step = q.step || stepFor(norm(title.textContent));
    setAttr(root, 'data-bb-layout', q.style || 'cards');
    setAttr(root, 'data-bb-question-id', id || null);
    setAttr(root, 'data-bb-multi', q.multi ? '' : null);
    var total = Math.max(TOTAL_STEPS, step);
    root.style.setProperty('--bb-pct', (step / total * 100) + '%');

    var wrapper = title.closest('[id^="quiz-kit-question-wrapper-"]');
    var question = wrapper && wrapper.parentElement;
    if (question) {
      setAttr(question, 'data-bb-question', '');
      // Never hide the panel: Quiz Kit only loads the image once the panel is on screen.
      var media = question.querySelector('[id^="quiz-kit-question-content-image-"]');
      var panel = media && childOf(question, media);
      if (panel === wrapper) panel = null;
      // Give the panel its column straight away so Quiz Kit sees it and loads the image.
      // If no image arrives within MEDIA_WAIT_MS, treat the question as image-free.
      var hasMedia = false;
      if (panel) {
        if (!panelSeen.has(panel)) { panelSeen.set(panel, Date.now()); setTimeout(request, MEDIA_WAIT_MS + 100); }
        hasMedia = !!panel.querySelector('img') || Date.now() - panelSeen.get(panel) < MEDIA_WAIT_MS;
      }
      setAttr(panel, 'data-bb-media-panel', hasMedia ? '' : null);
      setAttr(question, 'data-bb-media', hasMedia ? '' : null);
      clearBackgrounds(root, question);
      // Fade in each new question; fade the side image only when it changes.
      if (id !== lastQuestionId) {
        lastQuestionId = id;
        replay(question, 'data-bb-anim');
      }
      var img = panel && panel.querySelector('img');
      var src = img ? img.currentSrc || img.src : null;
      if (src && src !== lastMediaSrc) {
        lastMediaSrc = src;
        replay(question, 'data-bb-anim-media');
      }
    }
    setAttr(wrapper, 'data-bb-step-label', step + '/' + total);
    var container = title.closest('#quiz-kit-container') || title.parentElement;
    setAttr(container, 'data-bb-eyebrow', q.eyebrow || '');

    var scope = wrapper || root;
    var grid = scope.querySelector('[id^="quiz-kit-question-grid-"]');
    if (grid) {
      setAttr(grid, 'data-bb-sub', q.sub || '');
      var first = grid.querySelector('[id^="quiz-kit-question-multiple-choice-"]');
      if (first) {
        var group = first.parentElement;
        setAttr(group, 'data-bb-layout-group', q.style || 'cards');
        setAttr(group, 'data-bb-count', String(group.querySelectorAll('[id^="quiz-kit-question-multiple-choice-"]').length));
        group.querySelectorAll('[id^="quiz-kit-question-multiple-choice-"]').forEach(function (el) {
          setAttr(el, 'data-bb-choice', '');
        });
      }
    }

    // Back button: Quiz Kit's id varies and it can sit outside the navigation element.
    var next = root.querySelector('#quiz-kit-question-next-button');
    var back = root.querySelector('#quiz-kit-question-back-button') || findBack(root, next);
    root.querySelectorAll('[data-bb-back]').forEach(function (el) { if (el !== back) el.removeAttribute('data-bb-back'); });
    setAttr(back, 'data-bb-back', '');
    var nav = root.querySelector('#quiz-kit-question-navigation');
    if (nav && back && nav.contains(back)) setAttr(childOf(nav, back), 'data-bb-back-slot', '');
  }

  function sync() {
    var root = document.querySelector(ROOT);
    if (!root) return;
    var intro = root.querySelector('#quiz-kit-intro');
    if (intro && shown(intro)) return syncIntro(root, intro);
    var titles = root.querySelectorAll('[id^="quiz-kit-question-title-"]');
    var title = null;
    for (var i = 0; i < titles.length; i++) if (shown(titles[i])) { title = titles[i]; break; }
    if (title) syncQuestion(root, title);
  }

  var pending = false;
  function request() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; sync(); });
  }
  new MutationObserver(function (changes) {
    for (var i = 0; i < changes.length; i++) if (changes[i].type === 'childList') return request();
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', request);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', request); else request();
})();
